var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaSegmentList = function () {
  function MediaSegmentList(type) {
    _classCallCheck(this, MediaSegmentList);

    this._type = type;
    this._list = [];
    this._lastAppendLocation = -1; // cached last insert location
  }

  _createClass(MediaSegmentList, [{
    key: "isEmpty",
    value: function isEmpty() {
      return this._list.length === 0;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._list = [];
      this._lastAppendLocation = -1;
    }
  }, {
    key: "_searchNearestSegmentBefore",
    value: function _searchNearestSegmentBefore(beginDts) {
      var list = this._list;
      if (list.length === 0) {
        return -2;
      }
      var last = list.length - 1;
      var mid = 0;
      var lbound = 0;
      var ubound = last;

      var idx = 0;

      if (beginDts < list[0].originDts) {
        idx = -1;
        return idx;
      }

      while (lbound <= ubound) {
        mid = lbound + Math.floor((ubound - lbound) / 2);
        if (mid === last || beginDts > list[mid].lastSample.originDts && beginDts < list[mid + 1].originDts) {
          idx = mid;
          break;
        } else if (list[mid].originDts < beginDts) {
          lbound = mid + 1;
        } else {
          ubound = mid - 1;
        }
      }
      return idx;
    }
  }, {
    key: "_searchNearestSegmentAfter",
    value: function _searchNearestSegmentAfter(beginDts) {
      return this._searchNearestSegmentBefore(beginDts) + 1;
    }
  }, {
    key: "append",
    value: function append(segment) {
      var list = this._list;
      var lastAppendIdx = this._lastAppendLocation;
      var insertIdx = 0;

      if (lastAppendIdx !== -1 && lastAppendIdx < list.length && segment.originStartDts >= list[lastAppendIdx].lastSample.originDts && (lastAppendIdx === list.length - 1 || lastAppendIdx < list.length - 1 && segment.originStartDts < list[lastAppendIdx + 1].originStartDts)) {
        insertIdx = lastAppendIdx + 1; // use cached location idx
      } else {
        if (list.length > 0) {
          insertIdx = this._searchNearestSegmentBefore(segment.originStartDts) + 1;
        }
      }

      this._lastAppendLocation = insertIdx;
      this._list.splice(insertIdx, 0, segment);
    }
  }, {
    key: "getLastSegmentBefore",
    value: function getLastSegmentBefore(beginDts) {
      var idx = this._searchNearestSegmentBefore(beginDts);
      if (idx >= 0) {
        return this._list[idx];
      } else {
        // -1
        return null;
      }
    }
  }, {
    key: "getLastSampleBefore",
    value: function getLastSampleBefore(beginDts) {
      var segment = this.getLastSegmentBefore(beginDts);
      if (segment !== null) {
        return segment.lastSample;
      } else {
        return null;
      }
    }
  }, {
    key: "getLastRAPBefore",
    value: function getLastRAPBefore(beginDts) {
      var segmentIdx = this._searchNearestSegmentBefore(beginDts);
      var randomAccessPoints = this._list[segmentIdx].randomAccessPoints;
      while (randomAccessPoints.length === 0 && segmentIdx > 0) {
        segmentIdx--;
        randomAccessPoints = this._list[segmentIdx].randomAccessPoints;
      }
      if (randomAccessPoints.length > 0) {
        return randomAccessPoints[randomAccessPoints.length - 1];
      } else {
        return null;
      }
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "length",
    get: function get() {
      return this._list.length;
    }
  }]);

  return MediaSegmentList;
}();

export default MediaSegmentList;